import { lazyLoad } from "../../../../utils/loadable.js";

export const FAQ = lazyLoad(
    () => import("./index.js"),
    (module) => module.FAQ,
);
